export const BID_OVERVIEW_TABS = ['compliance', 'bidOverview', 'awardCriteria'] as const;

export const BID_TYPES = ['PREQUALIFICATION', 'MAIN_TENDER'] as const;

export const onlyBidCannotBeDeleted = {
  en: 'This is the only bid in this workspace and cannot be deleted',
  nb: 'Dette er det eneste tilbudet i dette arbeidsområdet og kan ikke slettes',
};

export enum BidStatus {
  DEFAULT = 0,
  SUBMITTED = 20,
}
